import ReactDOM from "react-dom/client";
import reportWebVitals from "reportWebVitals";

import { CurrentCountry } from "shared/components/CurrentCountry";
import { UnconnectedErrorBoundary as ErrorBoundary } from "shared/components/ErrorBoundary";

import "i18n";

import "@brandAssets/scss/error.scss";

ReactDOM.createRoot(document.getElementById("404-page")).render(
  <ErrorBoundary>
    <CurrentCountry />
  </ErrorBoundary>
);

reportWebVitals(console.log);
